import BaseApi from './BaseApi';

class PatientTreatmentHistoryApi extends BaseApi {
  public getTreatmentEpisodes(patientId: number | string) {
    return this.get(`/${patientId}/treatment-episodes`);
  }

  protected getSpecificApiPrefix(): string {
    return 'managers/patients';
  }
}

export default PatientTreatmentHistoryApi;
